export default "__VITE_ASSET__DiJEInG4__"